/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
  GetApiV1SerieSerieidLangsAvailableLanguagesPathParams,
  GetApiV1SerieSerieidLangsAvailableLanguages401,
  GetApiV1SerieSerieidLangsAvailableLanguages404,
  GetApiV1SerieSerieidLangsAvailableLanguages500,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangsAvailableLanguages.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerieSerieidLangsAvailableLanguages } from "../../clients/serieIdiomasController/getApiV1SerieSerieidLangsAvailableLanguages.ts";

export const getApiV1SerieSerieidLangsAvailableLanguagesQueryKey = (
  serieId: GetApiV1SerieSerieidLangsAvailableLanguagesPathParams["serieId"],
) =>
  [
    {
      url: "/api/v1/serie/:serieId/langs/available-languages",
      params: { serieId: serieId },
    },
  ] as const;

export type GetApiV1SerieSerieidLangsAvailableLanguagesQueryKey = ReturnType<
  typeof getApiV1SerieSerieidLangsAvailableLanguagesQueryKey
>;

export function getApiV1SerieSerieidLangsAvailableLanguagesQueryOptions(
  serieId: GetApiV1SerieSerieidLangsAvailableLanguagesPathParams["serieId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerieSerieidLangsAvailableLanguagesQueryKey(serieId);
  return queryOptions<
    GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangsAvailableLanguages401
      | GetApiV1SerieSerieidLangsAvailableLanguages404
      | GetApiV1SerieSerieidLangsAvailableLanguages500
    >,
    GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
    typeof queryKey
  >({
    enabled: !!serieId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerieSerieidLangsAvailableLanguages(serieId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os idiomas ainda não cadastrados para a série, para dropdown. **(Requer Authorization para autenticação)**
 * @summary Idiomas disponíveis (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/available-languages}
 */
export function useGetApiV1SerieSerieidLangsAvailableLanguages<
  TData = GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
  TQueryData = GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1SerieSerieidLangsAvailableLanguagesQueryKey,
>(
  serieId: GetApiV1SerieSerieidLangsAvailableLanguagesPathParams["serieId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerieSerieidLangsAvailableLanguages401
          | GetApiV1SerieSerieidLangsAvailableLanguages404
          | GetApiV1SerieSerieidLangsAvailableLanguages500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1SerieSerieidLangsAvailableLanguagesQueryKey(serieId);

  const query = useQuery(
    {
      ...getApiV1SerieSerieidLangsAvailableLanguagesQueryOptions(
        serieId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangsAvailableLanguages401
      | GetApiV1SerieSerieidLangsAvailableLanguages404
      | GetApiV1SerieSerieidLangsAvailableLanguages500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
